var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"hide-when-empty",rawName:"v-hide-when-empty"}],class:_vm._.actions},[(_vm.item.status === 0)?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '取消订单',
      id: 'cl9xjjs4q001u6krl7mjo4cdf',
    }),expression:"{\n      name: '取消订单',\n      id: 'cl9xjjs4q001u6krl7mjo4cdf',\n    }"}],class:_vm._.item,on:{"click":_vm.handleCancelClick}},[_vm._v(" 取消订单 ")]):_vm._e(),(_vm.item.status === 0)?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '立即支付',
      id: 'cl9xjk9zq001w6krl96tp47c7',
    }),expression:"{\n      name: '立即支付',\n      id: 'cl9xjk9zq001w6krl96tp47c7',\n    }"}],class:_vm._.item,on:{"click":_vm.handlePayClick}},[_vm._v(" 立即支付 ")]):_vm._e(),(_vm.item.status === 901)?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '删除订单',
      id: 'cl9xjkdaa001y6krl2lrxgzop',
    }),expression:"{\n      name: '删除订单',\n      id: 'cl9xjkdaa001y6krl2lrxgzop',\n    }"}],class:_vm._.item,on:{"click":_vm.handleDeleteClick}},[_vm._v(" 删除订单 ")]):_vm._e(),(
      (_vm.item.status === 100 || _vm.item.status === 102 || _vm.item.status === 400) &&
      _vm.item.urgedStatus !== -1
    )?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '提醒接单',
      id: 'cl9xjkggy00206krl8n5h1pg7',
    }),expression:"{\n      name: '提醒接单',\n      id: 'cl9xjkggy00206krl8n5h1pg7',\n    }"}],class:_vm._.item,on:{"click":_vm.handleRemindClick}},[_vm._v(" 提醒接单 ")]):_vm._e(),(
      _vm.item.saleAfterStatus === 0 &&
      (_vm.item.status === 400 || _vm.item.status === 401 || _vm.item.status === 900)
    )?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '申请售后',
      id: 'cl9xjkjnk00226krl0xab0e5r',
    }),expression:"{\n      name: '申请售后',\n      id: 'cl9xjkjnk00226krl0xab0e5r',\n    }"}],class:_vm._.item,on:{"click":_vm.handleRefundRequestClick}},[_vm._v(" 申请售后 ")]):_vm._e(),(
      _vm.item.saleAfterStatus === 1 ||
      _vm.item.saleAfterStatus === 2 ||
      _vm.item.saleAfterStatus === 3
    )?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '售后详情',
      id: 'cl9xjknaw00246krlhrv90ho6',
    }),expression:"{\n      name: '售后详情',\n      id: 'cl9xjknaw00246krlhrv90ho6',\n    }"}],class:_vm._.item,on:{"click":_vm.handleRefundDetailClick}},[_vm._v(" 售后详情 ")]):_vm._e(),(_vm.item.status === 402)?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '确认收货',
      id: 'cl9xjkqgc00266krl1byr9360',
    }),expression:"{\n      name: '确认收货',\n      id: 'cl9xjkqgc00266krl1byr9360',\n    }"}],class:_vm._.item,on:{"click":_vm.handleConfirmClick}},[_vm._v(" 确认收货 ")]):_vm._e(),(_vm.item.status === 900 || _vm.item.status === 902)?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '再来一单',
      id: 'cl9xjkth400286krl89slcayd',
    }),expression:"{\n      name: '再来一单',\n      id: 'cl9xjkth400286krl89slcayd',\n    }"}],class:_vm._.item,on:{"click":_vm.handleAgainClick}},[_vm._v(" 再来一单 ")]):_vm._e(),(
      (_vm.item.status === 900 || _vm.item.status === 902) &&
      _vm.item.evaluationStatus === 0
    )?_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      name: '评价',
      id: 'cl9xjkx2o002a6krl91caf71z',
    }),expression:"{\n      name: '评价',\n      id: 'cl9xjkx2o002a6krl91caf71z',\n    }"}],class:_vm._.item,on:{"click":_vm.handleCommentClick}},[_vm._v(" 评价 ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }